import { isObject } from 'angular';

import { None, Option } from '@contact/upgrade';

export type IConference = IGuest[];

export enum GuestType {
  AGENT,
  CONTACT,
  TARGET,
  SUPERVISOR,
}

export enum GuestState {
  INITIALIZED,
  CONNECTED,
  JOINING,
  PARKED,
}

export interface IGuest {
  type: GuestType;
  id: string;
  responseId: string;
  state: GuestState;
  removed: boolean;
}

export class Guest {
  static fromDto(dto: any): Option<IGuest> {
    if (!isObject(dto)) {
      return None;
    }

    return Option.of({
      conferenceId: dto.conferenceUuid,
      id: dto.uuid,
      responseId: dto.bookingUuid,
      type: Guest.guestTypeFromDto(dto.type),
      state: GuestState.INITIALIZED,
      removed: false,
    });
  }

  static stateFromDto(stateDto: string): GuestState {
    switch (stateDto) {
      case 'AVAILABLE':
        return GuestState.CONNECTED;
      case 'DIALING':
        return GuestState.JOINING;
      default:
        return GuestState[stateDto];
    }
  }

  private static guestTypeFromDto(typeDto): GuestType {
    switch (typeDto) {
      case 'CONTACT':
        return GuestType.CONTACT;
      case 'INTERNAL':
        return GuestType.TARGET;
      case 'EXTERNAL':
        return GuestType.TARGET;
      case 'SUPERVISOR':
        return GuestType.SUPERVISOR;
      case 'CSR':
      default:
        return GuestType.AGENT;
    }
  }
}
